import ecolierQuizzes from './ecolierQuizzes.json';
import banjaminQuizzes from './benjaminQuizzes.json';
import cadetQuizzes from './cadetQuizzes.json';
import juniorQuizzes from './juniorQuizzes.json';
import studentQuizzes from './studentQuizzes.json';



export const findQuizById = (idQuiz) => {
    return [...ecolierQuizzes, ...banjaminQuizzes, ...cadetQuizzes, ...juniorQuizzes, ...studentQuizzes].find(({ _id }) => idQuiz === _id);
};

